var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
	'block-wrapper', 
	_vm.componentClass, 
	_vm.colorMode, 
	_vm.styleClasses,
	{
		visible: _vm.visible, 
		ready: _vm.ready
	}
]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"columns small-12"},[_c('div',{staticClass:"row align-middle"},[_c('div',{ref:"textColumn",class:_vm.textColumns,style:({ 
						order: _vm.textOrder,
					})},[_c('wysiwyg-content',{ref:"textWrapper",attrs:{"data":_vm.data.wysiwyg_content,"columns":2}})],1),_c('div',{class:_vm.mediaColumns,style:({ order: _vm.mediaOrder})},[_c('media-content',{ref:"mediaWrapper",attrs:{"data":_vm.data.media_content,"ready":_vm.ready,"visible":_vm.visible}})],1)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }